import { render, staticRenderFns } from "./CreatePermissionGroupModal.vue?vue&type=template&id=5875f456&"
import script from "./CreatePermissionGroupModal.vue?vue&type=script&lang=js&"
export * from "./CreatePermissionGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports